const SvgCloseGlyph = props => (
  <svg width={16} height={16} viewBox='0 0 16 16' {...props}>
    <path d='M8 6.651l3.372-3.372a.954.954 0 111.349 1.35L9.349 8l3.372 3.372a.954.954 0 11-1.35 1.349L8 9.349 4.628 12.72a.954.954 0 11-1.349-1.35L6.651 8 3.28 4.628A.954.954 0 114.63 3.28L8 6.651z' />
  </svg>
);

export default SvgCloseGlyph;
